import { logger } from '@parrot-software/observability';

import type { ISubscriptionBlockApiPort } from '@subscriptions/application/ports';
import type { StoreViewDto } from '@subscriptions/application/dtos';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const subLog = logger.forDomain('SUB', { subdomain: 'lifecycle' });

/**
 * Use case for listing stores available to feed the subscription block
 * creation wizard's multiselect.
 */
export const fetchStoresForBlockUseCase = (port: ISubscriptionBlockApiPort) => {
  const execute = async (blockUuid?: string): Promise<StoreViewDto[]> => {
    try {
      return await port.listStores(blockUuid);
    } catch (error) {
      subLog.error('listStoresForBlock', extractErrorAttributes(error));
      throw error;
    }
  };

  return { execute };
};
